import { render } from "./HolidayOfficeClosureSection.vue?vue&type=template&id=250869b8"
import script from "./HolidayOfficeClosureSection.vue?vue&type=script&lang=js"
export * from "./HolidayOfficeClosureSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__